import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, PLATFORM_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideTranslateService, TranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideToastr } from 'ngx-toastr';
import { appRoutes } from './app.routes';
import { authInterceptor } from './features/auth/interceptors/auth.interceptor';
import { ToastrComponent } from './shared/components/toastr/toastr.component';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from './core/services/storage/storage.service';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr({
      timeOut: 5000,
      extendedTimeOut: 0,
      toastComponent: ToastrComponent,
      toastClass: 'braidsbook-toastr',
      tapToDismiss: false
    }),
    provideTranslateService({
      // enforceLoading ajoute un cache-buster (?enforceLoading=<timestamp>) à l'URL
      // des fichiers i18n pour éviter qu'un ancien fichier en cache navigateur masque
      // les nouvelles clés de traduction.
      loader: provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json', enforceLoading: true }),
      fallbackLang: 'en'
    }),
    provideAppInitializer(() => {
      const translateService: TranslateService = inject(TranslateService);
      const platformId = inject(PLATFORM_ID);
      const storageService = inject(StorageService);

      translateService.addLangs(['en', 'fr']);

      if (isPlatformBrowser(platformId)) {
        // Côté client : utiliser la langue préférée ou celle du navigateur
        const preferredLanguage = storageService.getItem('USER_PREFERRED_LANGUAGE');
        translateService.use(preferredLanguage ? preferredLanguage : translateService.getBrowserLang()!);
      } else {
        // Côté serveur : utiliser la langue par défaut
        translateService.use('en');
      }
    }),
    provideClientHydration(withEventReplay())
  ]
};
